function sessionRoute(url){
    let domain = new URL(url)
    if(domain){
        window.location.href= domain?.origin
    }
    
}
export default sessionRoute;